export default "__VITE_ASSET__CEPc8RVz__"